/*
 * @Description: 命名与排序
 * @Author: 杨志航
 * @Date: 2026-09-06 10:15:46
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'
import Main from './Main'
import DepartSetting from './DepartSetting'

const NameSort = ({ match, history }) => {

  return (
    <CacheSwitch>
      <Route path={match.path + '/departsetting'} component={DepartSetting} />
      <CacheRoute component={Main} />
    </CacheSwitch>
  )
}

export default NameSort